import { makeStyles } from "@material-ui/core/styles";

const chipUseStyle = makeStyles(() => ({
  root: {
    fontSize: 12,
    fontWeight: 600,
    backgroundColor: "var(--color-pale-teal)",
    color: "var( --color-primary)",
    borderRadius: "1px 10px 10px 1px",
    height: 24,
    margin: "2px",
    "&.Mui-disabled": {
      backgroundColor: "var( --color-light-grey)",
      color: " var(--color-medium-grey)",
      opacity: 1
    },
    "& .MuiChip-deleteIcon": {
      color: "var( --color-primary)",
      margin: "0px",
      "&.Mui-disabled": {
        color: " var(--color-medium-grey)"
      }
    }
  }
}));
export { chipUseStyle };
